import { IServicePeriodSchema } from '../../../../repositories/billing-tariffs/v1/publish-terms';

export function getPeriodId(period: IServicePeriodSchema): number {
  return period.days;
}
